<p-toast position="top-center" key="tenantManagerToast"></p-toast>
<p-confirmDialog key="tenant-manager-confirmation" appendTo="body"></p-confirmDialog>


<app-page-wrapper-component class="tw-flex tw-basis-full tw-items-stretch" [hideOptions]="true">

    <ng-template #extraTitleTemplate>
        {{this.service.selectedTenant?.displayName}} <span
            *ngIf="this.service.selectedTenant?.tenantName !== this.service.selectedTenant?.displayName"
            class="ml-1">({{this.service.selectedTenant?.tenantName}})</span>
    </ng-template>

    <ng-template #iconTemplate>
        <em class="fal fa-buildings"></em>
    </ng-template>

    <ng-template #contentTemplate>
        <section class="tw-flex tw-flex-col tw-basis-full">
            <router-outlet *ngIf="this.service.selectedTenant"></router-outlet>
        </section>
    </ng-template>

</app-page-wrapper-component>
